import React from 'react';
import { useSelector } from 'react-redux';
import Chip, { Color } from 'lib/Chip';
import { Color as ButtonColor } from 'lib/Button';
import CopyToClipboardButton from 'components/common/CopyToClipboardButton';
import { getAllocationReportConfig } from 'store/sharedCampaignPlan/selectors';
import { CampaignPlanSingleFurnitureCardItemProps } from './CampaignPlanSingleFurnitureCard.types';

const CampaignPlanSingleFurnitureCardItem = ({
  frameId,
  isDigital,
  frameSize,
  impressions,
  isImpressions,
  sot,
}: CampaignPlanSingleFurnitureCardItemProps): React.ReactElement => {
  const isImpressionsShared = useSelector(getAllocationReportConfig)?.impressions?.planned ?? false;

  return (
    <div
      data-test-id={`campaign-plan-single-furniture-card-item-${frameId}`}
      className="rounded-xl border border-gray-200 bg-white hover:bg-neutral-100"
    >
      <div className="w-full flex flex-col pt-3 px-3 pb-3 gap-2">
        <div className="flex flex-col gap-1">
          <div className="flex items-center justify-between gap-2">
            <div className="relative flex-1 group">
              <span className="block font-bold body-lg whitespace-nowrap">{frameId}</span>
              <CopyToClipboardButton
                dataTestId={`campaign-plan-copy-${frameId}`}
                textToCopy={frameId}
                color={ButtonColor.TERTIARY}
                svgClassnames="w-3 h-3 text-neutral-900"
                buttonClassnames="!p-1 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto absolute right-0 top-0"
                isDisabled={false}
              />
            </div>
            <Chip label={isDigital ? 'Digital' : 'Paper'} color={Color.PRIMARY} wrapperClassName="shrink-0" />
          </div>
          <div className="sub-header-base text-gray-700 min-w-0 truncate">{frameSize}</div>
        </div>
        <div className="flex gap-6">
          {isDigital && (
            <div>
              <div className="sub-header-sm text-gray-500">Booked SOT</div>
              <strong className="sub-header-base">{sot}</strong>
            </div>
          )}
          {isImpressions && isImpressionsShared && (
            <div>
              <div className="sub-header-sm text-gray-500">Booked Impressions</div>
              <strong className="sub-header-base">{impressions}</strong>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CampaignPlanSingleFurnitureCardItem;
